import { defineComponent as _defineComponent } from 'vue';
import { computed } from "vue";
import { useDatasetPathDestination } from "@/composables/datasetPathDestination";
export default /*#__PURE__*/ _defineComponent({
    __name: 'DatasetIndex',
    props: {
        historyDatasetId: null,
        path: null
    },
    setup(__props) {
        const props = __props;
        const { datasetPathDestination } = useDatasetPathDestination();
        const pathDestination = computed(() => datasetPathDestination.value(props.historyDatasetId, props.path));
        const directoryContent = computed(() => {
            if (!pathDestination.value) {
                return;
            }
            if (pathDestination.value.fileLink) {
                return;
            }
            if (pathDestination.value.isDirectory) {
                return removeParentDirectory(pathDestination.value.datasetContent, pathDestination.value.filepath);
            }
            else if (props.path === undefined || props.path === "undefined") {
                return pathDestination.value.datasetContent;
            }
            return pathDestination.value.datasetContent;
        });
        const errorMessage = computed(() => {
            if (!pathDestination.value) {
                return `Dataset is not composite!`;
            }
            if (pathDestination.value.fileLink) {
                return `is not a directory!`;
            }
            if (pathDestination.value.isDirectory) {
                return undefined;
            }
            else if (props.path === undefined || props.path === "undefined") {
                return undefined;
            }
            else {
                return `is not found!`;
            }
        });
        function removeParentDirectory(datasetContent, filepath) {
            return datasetContent.filter((entry) => {
                if (entry.path.startsWith(`${filepath}/`)) {
                    entry.path = entry.path.replace(`${filepath}/`, "");
                    return entry;
                }
            });
        }
        const fields = [
            {
                key: "path",
                sortable: true,
            },
            {
                key: "class",
                label: "Type",
                sortable: true,
            },
        ];
        return { __sfc: true, datasetPathDestination, props, pathDestination, directoryContent, errorMessage, removeParentDirectory, fields };
    }
});
